<h1>{{'TITLES.COMPANIES' | translate}}</h1>
<div class="table-container custom-scrollbar">
    <app-custom-expanded-accordion [title]="'STATS.TITLE'" [isOpen]="true" [icon]="'analytics'">
        <app-general-statistics content></app-general-statistics>
    </app-custom-expanded-accordion>
    
    <div class="seach-container">
        <div class="col-md-3"><input type="text" class="form-control"
                placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}" (keyup)="searchCompany($event.target.value)" />
        </div>
        <div class="col-md-3">
            <mat-select multiple class="form-control" placeholder="{{'PLACEHOLDERS.USERS' | translate}}"
                (selectionChange)="selectedUser($event.value)">
                <mat-option *ngFor="let user of users | async" [value]="user.id">
                    {{user.fullname}}</mat-option>
            </mat-select>
        </div>

        <div class="col-md-2">
            <mat-select class="form-control" name="status" [value]="2" (selectionChange)="selectedStatus($event.value)">
                <mat-option [value]="2">{{'LABELS.ALL' | translate}}</mat-option>
                <mat-option [value]="1">{{'LABELS.ACTIVE' | translate}}</mat-option>
                <mat-option [value]="0">{{'LABELS.INACTIVE' | translate}}</mat-option>
            </mat-select>
        </div>
        <div class="col-md-2">
            <mat-select class="form-control" name="status" [value]="2" (selectionChange)="selectedVerified($event.value)">
                <mat-option [value]="2">{{'LABELS.ALL' | translate}}</mat-option>
                <mat-option [value]="1">{{'LABELS.VERIFIED' | translate}}</mat-option>
                <mat-option [value]="0">{{'LABELS.NOTVERIFIED' | translate}}</mat-option>
            </mat-select>
        </div>
    </div>
    <br>

    <app-table [dataSource]="dataSource" [columns]="columns" [loading]="isLoading" [pageSize]="size"
        (actionClicked)="selectedCompany($event)" (colClicked)="orderByCol($event)">
        <ng-container paginator>
            <mat-paginator #MatPaginator [length]="total" [pageSizeOptions]="[5, 10, 25, 100]"
                (page)="getCompaniesByPaginator(MatPaginator.pageIndex+1,MatPaginator.pageSize)">
            </mat-paginator>
        </ng-container>
    </app-table>
</div>